<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ isEditing ? "Edit Curriculum" : "Create New Curriculum" }}
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-field label="Title" label-position="on-border">
        <b-input
          ref="titleInput"
          v-model="formData.title"
          placeholder="Enter curriculum title"
          required
        />
      </b-field>

      <b-field label="Description" label-position="on-border">
        <b-input
          v-model="formData.description"
          type="textarea"
          placeholder="Enter curriculum description"
        />
      </b-field>

      <b-field label="Status" label-position="on-border">
        <b-select v-model="formData.status" placeholder="Select status">
          <option v-for="status in statusOptions" :key="status" :value="status">
            {{ status }}
          </option>
        </b-select>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button
        type="is-primary"
        :loading="isLoading"
        :disabled="!isValid"
        @click="$emit('submit', formData)"
      >
        {{ isEditing ? "Update" : "Create" }}
      </b-button>
      <b-button type="is-light" @click="$emit('close')">Cancel</b-button>
    </footer>
  </div>
</template>

<script>
import { ContentStatus } from "vue-chess-shared";

export default {
  name: "CurriculumEditor",

  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      statusOptions: Object.values(ContentStatus),
    };
  },

  computed: {
    isValid() {
      return this.formData.title.trim().length > 0;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.titleInput) {
        this.$refs.titleInput.focus();
      }
    });
  },
};
</script>
